import { clearAuthCookies, makeRequest, stopMasquerading } from "../util";
import { signOut } from "@/auth/firebase";
import { clearDarkModeFlagCache } from "@/theme/darkModeFlagCache";
import { clearWizardSessions } from "@/wizards/framework/storage";

export function signout() {
  stopMasquerading();
  clearDarkModeFlagCache();
  clearWizardSessions();
  makeRequest("invalidate_token")
    .then(() => {
      void signOut();
      clearAuthCookies();
    })
    .catch((_error) => {
      void signOut();
      clearAuthCookies();
    });
}
